/**
 * 模版市场-我使用过的模版空白提示
 * @author VenDream
 * @since 17/11/13
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import emptyTplTips from 'assets/images/empty-tpl.png';

export default class MyusedEmptyTips extends Component {
  static propTypes = {
    gotoIndex: PropTypes.func,
  };

  constructor() {
    super();

    // 倒计时时长
    this.delay = 3;

    // 倒计时指针
    this.timer = null;
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  // 启动倒计时
  startCountdown() {
    let delay = this.delay;

    clearInterval(this.timer);
    this.timer = setInterval(() => {
      delay -= 1;
      this.countdown && (this.countdown.innerText = delay);

      if (delay === 0) {
        clearInterval(this.timer);
        this.props.gotoIndex();
      }
    }, 1000);
  }

  render() {
    return (
      <div className="my-used-empty">
        <img src={emptyTplTips} alt="EMPTY_TIPS" className="tips-img" />
        <div className="tips">
          <span className="tips-text">
            您尚未使用任何模板，
            <span className="countdown" ref={node => (this.countdown = node)}>
              {this.delay}
            </span>
            秒后进入
          </span>
          <span className="tips-link" onClick={this.gotoIndex}>
            模板市场
          </span>
        </div>
      </div>
    );
  }
}
